import { render, staticRenderFns } from "./DateTimeLanguageConfig.vue?vue&type=template&id=2c18dc54&scoped=true"
import script from "./DateTimeLanguageConfig.vue?vue&type=script&lang=js"
export * from "./DateTimeLanguageConfig.vue?vue&type=script&lang=js"
import style0 from "./DateTimeLanguageConfig.vue?vue&type=style&index=0&id=2c18dc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c18dc54",
  null
  
)

export default component.exports